export default "__VITE_ASSET__DESj4xAc__"